import { RadioButton, RadioButtonHandle } from "@progress/kendo-react-inputs";
import { SurveyEngine_Models_BaseResponse, SurveyEngine_Models_GetResponseResponse, SurveyEngine_Models_ScaleMatrixResponse, SurveyEngine_Models_StartGridAnswer, SurveyEngine_Models_StartGridQuestion, SurveyEngine_Models_StartGridResponse } from "../../../api"
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import parse from 'html-react-parser'
import { Label, Error } from "@progress/kendo-react-labels";
import { Fragment, useEffect, useRef, useState } from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";
import useCheckMobileScreen from "../../../Hooks/useCheckMobileScreen";
import { GetResponseAnswerData } from "../../../Common/Commands";
import { GetResponse } from "../GetResponse/GetResponse";
import { useGlobalCtx } from "../../../Context/GlobalContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { useUserResponseCtx } from "../../../Context/SurveyContext";
import React from "react";

interface ScaleMatrixProps {
  id: number
  message: string,
  questions: SurveyEngine_Models_StartGridQuestion[]
  answers: SurveyEngine_Models_StartGridAnswer[]
  defaultAnswer: SurveyEngine_Models_StartGridResponse[]
  isError: boolean
  focus: boolean
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}
interface ScaleMatrixAnswerItem {
  commandIndex: number,
  answerValue: number
}
export const ScaleMatrixNew = React.memo((props: ScaleMatrixProps) => {

  const [answers, setAnswers] = useState<Array<SurveyEngine_Models_StartGridResponse>>(props.defaultAnswer)
  const [isError, setIsError] = useState<boolean>(props.isError)
  const {isMobile,Size} = useCheckMobileScreen()
  

  const globalCTX = useGlobalCtx()

  const focusQuestion = useRef<SurveyEngine_Models_StartGridQuestion>({});
  const focusRadioButton = useRef<RadioButtonHandle>(null);

  if (props.isError) {
    for (let i = 0; i < props.questions.length; i++) {

      if (!answers.find(a => a.commandIndex === props.questions[i].commandIndex)) {
        focusQuestion.current = props.questions[i];
        break;
      }
    }
  }
  else {
    if(props.focus)focusQuestion.current = props.questions[0];
  }
  // const cols = [
  //   {
  //     width: 250,
  //   }
  // ]
  // props.answers.forEach(()=>{
  //   cols.push({
  //     width: 45,
  //   })
  // })

  // const rows = [
  //   {
  //     height: 50,
  //   }
  // ]
  // props.questions.forEach(()=>{
  //   rows.push({
  //     height: 50,
  //   })
  // })
  useEffect(() => {
    focusRadioButton.current?.focus()
    if(props.defaultAnswer.length > 0){
      let res: SurveyEngine_Models_ScaleMatrixResponse = {
        commandIndex: props.id,
        commandType: "ScaleMatrix",
        answers: props.defaultAnswer
      }
      props.callback(res)
    }
    setIsError(props.isError);
    setAnswers(answers)
  }, [props])

  const handleGetResponseAnswer = (response: SurveyEngine_Models_GetResponseResponse) => {
    //handleSelection({answerValue:response.selectedId!,commandIndex:response.commandIndex!})
    let draft: Array<SurveyEngine_Models_StartGridResponse> = answers ?? [];
    
    let ansIndex = draft.findIndex(a => a.commandIndex === response.commandIndex);
    if (ansIndex !== -1) {
      draft.splice(ansIndex, 1)
    }
    draft.push({
      commandIndex: response.commandIndex,
      answerValue: response.selectedId,
      commandType: "StartGridResponse"
    })
    setAnswers(draft);
    if (draft.length < props.questions.length) {
      setIsError(true)
    } else {
      let res: SurveyEngine_Models_ScaleMatrixResponse = {
        commandIndex: props.id,
        commandType: 'ScaleMatrix',
        answers: draft,
      }
      props.callback(res)
      setIsError(false)
    }
    
    if (draft.length === props.questions.length) {
      setIsError(false);
    }
  }

 
  const handleSelection = (selection: ScaleMatrixAnswerItem) => {

    let draft: Array<SurveyEngine_Models_StartGridResponse> = [...answers]
    const ans = draft.find(res => res.commandIndex === selection.commandIndex)
    if (ans) {
      ans.answerValue = selection.answerValue
    }
    else {
      draft.push(
        {
          commandIndex: selection.commandIndex,
          answerValue: selection.answerValue,
          commandType: "StartGridResponse"
        });
    }

    setAnswers(draft);

    if (draft.length < props.questions.length) {
      setIsError(true)
    } else {
      let res: SurveyEngine_Models_ScaleMatrixResponse = {
        commandIndex: props.id,
        commandType: 'ScaleMatrix',
        answers: draft,
      }
      props.callback(res)
      setIsError(false)
    }
    
    if (draft.length === props.questions.length) {
      setIsError(false);
    }

  }
  const isChecked = (selection: ScaleMatrixAnswerItem) => {

    const ans = answers.find(res => res.commandIndex === selection.commandIndex)
    if (ans) {
      if (ans.answerValue === selection.answerValue) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }
  const TooltipContentTemplate = (props:any) => {
    return (
        <>
        {parse(props.title)}
        </>
    );
  };
  const getHeader = () => {
    let header = <Fragment key="header">
      <GridLayoutItem row={1} col={1}></GridLayoutItem>
      {props.answers.map((item, index) => {
        return <GridLayoutItem key={`ah_${index + 2}`} row={1} col={index + 2} className="theme-scale-matrix-header-row"><Label id={`a_${index + 2}`} className="text-base font-semibold break-words" >{parse(item.text?.replace(/""/g,'"') ?? "")}</Label></GridLayoutItem>
      })}

{props.answers.map((item, index) => {
        return <GridLayoutItem key={`ahr_${index + 2}`} row={2} col={index + 2} className="theme-scale-matrix-header-row-rule"></GridLayoutItem>
      })}

    </Fragment>
    return header;
  }
  const getBody = () => {
    let body = <Fragment key="body">
      {props.questions.map((question, qindex) => {

        return <Fragment key={`bodyrow_${qindex}`}>
          <GridLayoutItem key={`qb_${qindex}`} row={qindex + 3} col={1}>

            <Label id={`q_${qindex + 3}`}>
              <span className={isError && !answers.find(e => e.commandIndex === question.commandIndex) ? "theme-scale-matrix-answer-row theme-validator-error-text text-base font-semibold " : "theme-scale-matrix-answer-row text-base font-semibold"}>
                {parse(question.message?.replace(/""/g,'"') ?? "")}
              </span>
            </Label>

          </GridLayoutItem>
          {props.answers.map((answer, rindex) => {
            let focusAnswer = false;
            let checkState = isChecked({ commandIndex: question.commandIndex!, answerValue: answer.answerValue! })
            if (question.commandIndex === focusQuestion.current.commandIndex && (checkState || rindex === 0)) {
              focusAnswer = true;
            }
            if (qindex + 3 === 3 && rindex + 2 === 2) {
              return <GridLayoutItem className='theme-answer theme-scale-matrix-row' key={`ab_${rindex + 2}`} row={qindex + 3} col={rindex + 2}>
                <Tooltip position={"top"} anchorElement={"target"} content={(props) => <TooltipContentTemplate title={props.title} />} >
                  <RadioButton ref={props.focus && focusAnswer ? focusRadioButton : undefined} title={answer.text ?? ""} name={`ci_${props.id}_bodyrow_${qindex}`} aria-labelledby={`msglabel_${props.id.toString()} q_${qindex + 2} a_${rindex + 2}`}
                    onClick={() => handleSelection({ commandIndex: question.commandIndex!, answerValue: answer.answerValue! })}
                    checked={checkState} />
                </Tooltip>
              </GridLayoutItem>
            }
            else {
              return <GridLayoutItem className='theme-answer theme-scale-matrix-row' key={`ab_${rindex + 2}`} row={qindex + 3} col={rindex + 2}>
                <Tooltip position={"top"} anchorElement={"target"} content={(props) => <TooltipContentTemplate title={props.title} />}>
                  <RadioButton ref={props.focus && focusAnswer ? focusRadioButton : undefined} title={answer.text ?? ""} name={`ci_${props.id}_bodyrow_${qindex}`} aria-labelledby={`q_${qindex + 2} a_${rindex + 2}`}
                    onClick={() => handleSelection({ commandIndex: question.commandIndex!, answerValue: answer.answerValue! })}
                    checked={checkState} />
                </Tooltip>
              </GridLayoutItem>
            }

          })}
        </Fragment>
      })}
    </Fragment>
    return body;
  }
  return (
    <div className="theme-scale-matrix">
      <Label
        className="theme-question text-xl font-semibold"
        id={`msglabel_${props.id.toString()}`}>
        {parse(props.message?.replace(/""/g,'"') ?? "")}
      </Label>
      {isMobile || (Size < 1400 && props.answers.length > 9)? <div className="pt-5">
        {props.questions.map((item, qindex) => {
          let ansItem = answers.find(e => e.commandIndex === item.commandIndex);
          return <div key={`gr_${qindex}`} className="pb-2">
            <GetResponse
              id={item.commandIndex!}
              question={item.message!}
              answers={props.answers.map((item, index) => {
                let getResAns: GetResponseAnswerData = {
                  label: item.text!,
                  isOpenEnded: false,
                  otherValue: "",
                  value: item.answerValue!
                }
                return getResAns;
              })}
              defaultAnswer={ansItem?.answerValue?.toString() ?? ""}
              layout={"Vertical"}
              isError={isError && ansItem === undefined}
              focus={item.commandIndex === focusQuestion.current.commandIndex}
              callback={handleGetResponseAnswer} />
          </div>
        })}
      </div> :
        <>
          <GridLayout
            className="theme-scale-matrix-grid pt-5 mb-3"
            align={{ horizontal: 'stretch', vertical: 'middle' }}
            gap={{
              rows: 10,
              cols: 0
            }}>
            {getHeader()}
            {getBody()}
          </GridLayout>
        </>}
      {isError && !isMobile && !(Size < 1400 && props.answers.length > 9) && <Error className="theme-validator-error-text font-semibold" direction='start'><FontAwesomeIcon icon={faCircleExclamation} className="theme-icon-spacer" />{globalCTX.LangResources.scaleMatrixMsg.noResponseErrorMsg}</Error>}
    </div>
  );
});